<template>
  <pt-news-form class="pt-news-form__page" :id="id" :isEdit="is_edit"></pt-news-form>
</template>

<script>
import PtNewsForm from 'cps/information-manage/pt-news-manage/pt-news-form'
export default {
  name: 'pt-news-form__view',
  components: {
    'pt-news-form': PtNewsForm
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: [Boolean, String],
      default: false
    }
  },
  data () {
    return {
      is_edit: this.isEdit === 'true'
    }
  }
}
</script>
